module.exports = __webpack_public_path__ + "static/media/login_spinner.73c27895.gif";